import { animate, style, transition, trigger } from '@angular/animations';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { PreloadService } from './../../services/preload.service';
import { TutorialService } from './../../services/tutorial.service';

@Component({
  selector: 'app-title-screen',
  templateUrl: './title-screen.component.html',
  styleUrls: ['./title-screen.component.less'],
  animations: [
    trigger(
      'outAnimation',
      [
        transition(
          ':leave',
          [
            animate('0.3s ease-in-out',
              style({ opacity: 0 }))
          ]
        )
      ]
    ),
    trigger(
      'inOutAnimation',
      [
        transition(
          ':enter',
          [style({ opacity: 0 }),
          animate('0.8s ease-in-out',
            style({ opacity: 1 }))
          ]
        ),
        transition(
          ':leave',
          [
            animate('0.1s ease-in-out',
              style({ opacity: 0 }))
          ]
        )
      ]
    )
  ]
})
export class TitleScreenComponent implements OnInit, OnDestroy {

  constructor(private router: Router, private tutorialService: TutorialService, private preloadService: PreloadService) { }

  public loading: boolean = true;
  public index: number = 0;
  private preloadSub: Subscription;
  ngOnDestroy() {
    if (this.preloadSub) this.preloadSub.unsubscribe();
  }
  ngOnInit(): void {
    this.loading = true;
    this.index = 0;
    this.preloadService.preload();
    this.preloadSub = this.preloadService.progress.subscribe(r => {
      if (r >= 100) {
        this.loading = false;
        /* if (this.tutorialService.getTutorialPassed("title")) {
           this.router.navigate(["main-menu"]);
         } else {*/
        this.next();
        this.preloadSub.unsubscribe();
        //}
      }

    })
  }

  public get progress() {
    return this.preloadService.progress;
  }

  public next() {
    if (!this.loading) {
      if (this.index < 3) {
        this.index++;

      } else {
        this.tutorialService.setPagePassed("title");
        this.router.navigate(["main-menu"])
      }
    }

  }

}
